/**
 * Wallet PaymentIntents exclude redirect payment methods at creation time.
 * Keep this confirmation in-page so a Stripe return URL cannot place the
 * PaymentIntent client secret in a request seen by the ALB.
 */
export const WALLET_DEPOSIT_CONFIRM_OPTIONS = {
  redirect: "if_required",
} as const;

export function confirmWalletDeposit(stripe: Stripe, elements: StripeElements) {
  return stripe.confirmPayment({
    elements,
    ...WALLET_DEPOSIT_CONFIRM_OPTIONS,
  });
}
import type { Stripe, StripeElements } from "@stripe/stripe-js";
